import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import {
  Card,
  Grid,
  Tooltip,
  IconButton,
  Switch,
} from "@mui/material";

import { Link } from "react-router-dom";
import MDButton from "components/MDButton";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

export default class ResultsList extends Component {
  state = {
    results: [],
    per_page: 10,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalDocs: 0,
      limit: 10,
    },
    notification: false,
    message: "",
    notiColor: "success",
    loading: false,
  };

  componentDidMount() {
    this.getAllResults(this.state.page_no, this.state.per_page);
  }

  // ✅ FETCH RESULTS
  getAllResults = async (page = 1, limit = 10) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    try {
      const resp = await axios.post(
        Constants.getUrls.getAllResults,
        { page, limit }
      );

      if (resp.data.status) {
        const data = resp.data.data || {};
        const rows = data.rows || [];

        const pagination = {
          page: data.pagination?.currentPage || page,
          limit: data.pagination?.limit || limit,
          totalDocs: data.pagination?.total || rows.length,
          totalPages: data.pagination?.totalPages || 1,
          hasNextPage: data.pagination?.hasNextPage,
          hasPrevPage: data.pagination?.hasPrevPage,
        };

        this.setState({
          results: rows,
          pagination,
          loading: false,
        });
      }
    } catch {
      this.setState({
        notification: true,
        message: "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  // ✅ DELETE
  handleDelete = async (id) => {
    if (!window.confirm("Delete this result?")) return;

    try {
      const resp = await axios.post(
        Constants.deleteUrls.deleteResult,
        { id }
      );

      this.setState({
        notification: true,
        message: resp.data.message || "Deleted successfully",
        notiColor: "success",
      });

      this.getAllResults(
        this.state.pagination.page,
        this.state.per_page
      );
    } catch {
      this.setState({
        notification: true,
        message: "Delete failed!",
        notiColor: "warning",
      });
    }
  };

  // ✅ STATUS
  handleStatusChange = async (id, currentStatus) => {
    const newStatus = currentStatus === "1" ? "0" : "1";

    try {
      const resp = await axios.post(
        Constants.putUrls.changeResultStatus,
        { id, status: newStatus }
      );

      if (resp.data.status) {
        this.setState({
          notification: true,
          message: resp.data.message || "Status updated",
          notiColor: "success",
        });

        this.getAllResults(
          this.state.pagination.page,
          this.state.per_page
        );
      }
    } catch {
      this.setState({
        notification: true,
        message: "Status update failed!",
        notiColor: "warning",
      });
    }
  };

  handlePageChange = (page) => {
    this.getAllResults(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.getAllResults(1, limit);
    });
  };

  render() {
    const { results, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Results List
              </MDTypography>
            </MDBox>

            {/* 🔥 ADD BUTTON */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addresults">
                <MDButton variant="contained" color="primary">
                  Add New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : results.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial" },
                      { Header: "Result Date", accessor: "date" },
                      { Header: "Course", accessor: "course" },
                      { Header: "Level", accessor: "level" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],

                    rows: results.map((item, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit +
                        (index + 1),

                      date: item.result_date || "-",
                      course: item.course_name || "-",
                      level: item.level_name || "-",


                      status: (
                        <Switch
                          checked={item.status === "1"}
                          onChange={() =>
                            this.handleStatusChange(
                              item.id,
                              item.status
                            )
                          }
                          color="success"
                        />
                      ),

                      action: (
                        <>
                          <Tooltip title="Edit">
                            <Link to={`/updateResult/${item.id}`}>
                              <IconButton color="info">
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete">
                            <IconButton
                              color="error"
                              onClick={() =>
                                this.handleDelete(item.id)
                              }
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={
                    this.handleEntriesPerPageChange
                  }
                />
              ) : (
                <div style={{ padding: 20 }}>No Results Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              title="Results"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}